export const GRID_CLASSNAMES: Record<number, string> = {
  1: 'grid grid-cols-1',
  2: 'grid grid-cols-2',
  3: 'grid grid-cols-3',
  4: 'grid grid-cols-3 lg:grid-cols-4',
};
